import { render, staticRenderFns } from "./f_users_table.vue?vue&type=template&id=085218e8&scoped=true&"
import script from "./f_users_table.vue?vue&type=script&lang=js&"
export * from "./f_users_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085218e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085218e8')) {
      api.createRecord('085218e8', component.options)
    } else {
      api.reload('085218e8', component.options)
    }
    module.hot.accept("./f_users_table.vue?vue&type=template&id=085218e8&scoped=true&", function () {
      api.rerender('085218e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/f_exchange/users/f_users_table.vue"
export default component.exports